module.exports = __webpack_public_path__ + "static/img/054.4b49b74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/054.png
// module id = L0Wv
// module chunks = 0